/**
 * 工作台 - 关键业务指标 页签配置
 *
 * tradeType:  1、采购方   2、供应商
 *
 */
export const BILLTYPE_CONFIG = {
  '1001': {
    billType: '10',
    billName: '采购单',
    tabId: '1001',
    tabName: '待送审',
    listRouter: '/purchase/order/list/9'
  },
  '1002': {
    billType: '10',
    billName: '采购单',
    tabId: '1002',
    tabName: '待发布',
    listRouter: '/purchase/order/list/8'
  },
  '1003': {
    billType: '10',
    billName: '采购单',
    tabId: '1003',
    tabName: '差异待处理',
    listRouter: '/purchase/order/list/3'
  },
  '1004': {
    billType: '10',
    billName: '采购单',
    tabId: '1004',
    tabName: '待签章',
    listRouter: '/purchase/order/list/5'
  },
  '1005': {
    billType: '10',
    billName: '采购单',
    tabId: '1005',
    tabName: '逾期答交',
    listRouter: '/purchase/order/list'
  },
  '1006': {
    billType: '10',
    billName: '采购单',
    tabId: '1006',
    tabName: '逾期交货',
    listRouter: '/purchase/order/list'
  },
  '1007': {
    billType: '10',
    billName: '采购单',
    tabId: '1007',
    tabName: '待审批',
    listRouter: '/purchase/order/list/9'
  },
  '1008': {
    billType: '10',
    billName: '采购单',
    tabId: '1008',
    tabName: '待答交',
    listRouter: '/purchase/order/list/1'
  },
  '1009': {
    billType: '10',
    billName: '采购单',
    tabId: '1009',
    tabName: '退回待答交',
    listRouter: '/purchase/order/list/1'
  },
  '1101': {
    billType: '11',
    billName: '采购变更单',
    tabId: '1101',
    tabName: '差异待处理',
    listRouter: '/purchase/change/list/2'
  },
  '1102': {
    billType: '11',
    billName: '采购变更单',
    tabId: '1102',
    tabName: '待确认',
    listRouter: '/purchase/change/list/1'
  },
  '1201': {
    billType: '12',
    billName: '收货单',
    tabId: '1201',
    tabName: '待发布',
    listRouter: '/purchase/receive/note/list/4'
  },
  '1202': {
    billType: '12',
    billName: '收货单',
    tabId: '1202',
    tabName: '无送货单',
    listRouter: '/purchase/receive/note/list/2'
  },
  '1203': {
    billType: '12',
    billName: '收货单',
    tabId: '1203',
    tabName: '同步失败',
    listRouter: '/purchase/receive/note/list/3'
  },
  '1301': {
    billType: '13',
    billName: '入库单',
    tabId: '1301',
    tabName: '待发布',
    listRouter: '/purchase/receive/note/list/41'
  },
  '1302': {
    billType: '13',
    billName: '入库单',
    tabId: '1302',
    tabName: '同步失败',
    listRouter: '/purchase/receive/note/list/31'
  },
  '1501': {
    billType: '15',
    billName: '来料检验',
    tabId: '1501',
    tabName: '检验中',
    listRouter: '/purchase/iqc/list/1'
  },
  '1502': {
    billType: '15',
    billName: '来料检验',
    tabId: '1502',
    tabName: '待发布',
    listRouter: '/purchase/iqc/list/3'
  },
  '1503': {
    billType: '15',
    billName: '来料检验',
    tabId: '1503',
    tabName: '退回待处理',
    listRouter: '/purchase/iqc/list/2'
  },
  // '1504': {
  //   billType: '15',
  //   billName: '来料检验',
  //   tabId: '1504',
  //   tabName: '待发起8D',
  //   listRouter: '/purchase/iqc/list'
  // },
  '1505': {
    billType: '15',
    billName: '来料检验',
    tabId: '1505',
    tabName: '待确认',
    listRouter: '/purchase/iqc/list/4'
  },
  '1601': {
    billType: '16',
    billName: '交料通知',
    tabId: '1601',
    tabName: '待发布',
    listRouter: '/purchase/delivery-change/list/1'
  },
  '1602': {
    billType: '16',
    billName: '交料通知',
    tabId: '1602',
    tabName: '差异待处理',
    listRouter: '/purchase/delivery-change/list/6'
  },
  '1603': {
    billType: '16',
    billName: '交料通知',
    tabId: '1603',
    tabName: '待确认',
    listRouter: '/purchase/delivery-change/list/2'
  },
  '1604': {
    billType: '16',
    billName: '交料通知',
    tabId: '1604',
    tabName: '退回待答交',
    listRouter: '/purchase/delivery-change/list/3'
  },
  '1901': {
    billType: '19',
    billName: '请购单',
    tabId: '1901',
    tabName: '待送审',
    listRouter: '/purchase/requisition/list'
  },
  '1902': {
    billType: '19',
    billName: '请购单',
    tabId: '1902',
    tabName: '待审批',
    listRouter: '/purchase/requisition/list'
  },
  // '1950': {
  //   billType: '19B',
  //   billName: '请购需求',
  //   tabId: '1950',
  //   tabName: '待分配',
  //   listRouter: '/purchase/requisition/board'
  // },
  // '1951': {
  //   billType: '19B',
  //   billName: '请购需求',
  //   tabId: '1951',
  //   tabName: '待采购',
  //   listRouter: '/purchase/requisition/board/1'
  // },
  // '1952': {
  //   billType: '19B',
  //   billName: '请购需求',
  //   tabId: '1952',
  //   tabName: '待询价',
  //   listRouter: '/purchase/requisition/board/2'
  // },
  '2201': {
    billType: '22',
    billName: '送货单',
    tabId: '2201',
    tabName: '申请确认',
    listRouter: '/purchase/receive/notify/list/3'
  },
  // '2202': {
  //   billType: '22',
  //   billName: '送货单',
  //   tabId: '2202',
  //   tabName: '待签收',
  //   listRouter: '/purchase/receive/notify/list/2'
  // },
  // '2203': {
  //   billType: '22',
  //   billName: '送货单',
  //   tabId: '2203',
  //   tabName: '签收中',
  //   listRouter: '/purchase/receive/notify/list/1'
  // },
  '2204': {
    billType: '22',
    billName: '送货单',
    tabId: '2204',
    tabName: '待检验',
    listRouter: '/purchase/receive/notify/list/4'
  },
  // '7701': {
  //   billType: '77',
  //   billName: '送样通知',
  //   tabId: '7701',
  //   tabName: '待签收',
  //   listRouter: '/purchase/receive/sample/list'
  // },
  // '7702': {
  //   billType: '77',
  //   billName: '送样通知',
  //   tabId: '7702',
  //   tabName: '签收中',
  //   listRouter: '/purchase/receive/sample/list'
  // },
  '2601': {
    billType: '26',
    billName: '延迟送货申请',
    tabId: '2601',
    tabName: '待确认',
    listRouter: '/purchase/delivery-delay/list/1'
  },
  '2602': {
    billType: '26',
    billName: '延迟送货申请',
    tabId: '2602',
    tabName: '已退回',
    listRouter: '/purchase/delivery-delay/list/2'
  },
  '2701': {
    billType: '27',
    billName: '8D报告',
    tabId: '2701',
    tabName: '待发布',
    listRouter: '/purchase/iqc/8d-report/list/1'
  },
  '2702': {
    billType: '27',
    billName: '8D报告',
    tabId: '2702',
    tabName: '待审核',
    listRouter: '/purchase/iqc/8d-report/list/4'
  },
  '2703': {
    billType: '27',
    billName: '8D报告',
    tabId: '2703',
    tabName: '待结案',
    listRouter: '/purchase/iqc/8d-report/list/3'
  },
  '2704': {
    billType: '27',
    billName: '8D报告',
    tabId: '2704',
    tabName: '逾期未结案',
    listRouter: '/purchase/iqc/8d-report/list/6'
  },
  '2705': {
    billType: '27',
    billName: '8D报告',
    tabId: '2705',
    tabName: '待改善',
    listRouter: '/purchase/iqc/8d-report/list/2'
  },
  '3001': {
    billType: '30',
    billName: '排程',
    tabId: '3001',
    tabName: '待发布',
    listRouter: '/purchase/plan/schedule/list/1'
  },
  '3002': {
    billType: '30',
    billName: '排程',
    tabId: '3002',
    tabName: '差异待处理',
    listRouter: '/purchase/plan/schedule/list/3'
  },
  '3003': {
    billType: '30',
    billName: '排程',
    tabId: '3003',
    tabName: '待答交',
    listRouter: '/purchase/plan/schedule/list/2'
  },
  '3004': {
    billType: '30',
    billName: '排程',
    tabId: '3004',
    tabName: '退回待答交',
    listRouter: '/purchase/plan/schedule/list/2'
  },
  '3201': {
    billType: '32',
    billName: '预检申请',
    tabId: '3201',
    tabName: '待确认',
    listRouter: '/purchase/iqc/pre-inspect-apply/list'
  },
  '3202': {
    billType: '32',
    billName: '预检申请',
    tabId: '3202',
    tabName: '检验中',
    listRouter: '/purchase/iqc/pre-inspect-apply/list/2'
  },
  '5101': {
    billType: '51',
    billName: '询价单',
    tabId: '5101',
    tabName: '待发布',
    listRouter: '/purchase/inquiry/prod/list'
  },
  '5102': {
    billType: '51',
    billName: '询价单',
    tabId: '5102',
    tabName: '已撤回',
    listRouter: '/purchase/inquiry/prod/list'
  },
  '5201': {
    billType: '52',
    billName: '对账单',
    tabId: '5201',
    tabName: '待发布',
    listRouter: '/purchase/billing/statement/list/1'
  },
  '5202': {
    billType: '52',
    billName: '对账单',
    tabId: '5202',
    tabName: '待确认',
    listRouter: '/purchase/billing/statement/list/2'
  },
  '5203': {
    billType: '52',
    billName: '对账单',
    tabId: '5203',
    tabName: '待签章',
    listRouter: '/purchase/billing/statement/list'
  },
  '5301': {
    billType: '53',
    billName: '发票单',
    tabId: '5301',
    tabName: '待确认',
    listRouter: '/purchase/billing/invoice/list/2'
  },
  '5401': {
    billType: '54',
    billName: '费用单',
    tabId: '5401',
    tabName: '待发布',
    listRouter: '/purchase/billing/cost/list/1'
  },
  '5402': {
    billType: '54',
    billName: '费用单',
    tabId: '5402',
    tabName: '已撤回',
    listRouter: '/purchase/billing/cost/list'
  },
  '5403': {
    billType: '54',
    billName: '费用单',
    tabId: '5403',
    tabName: '退回待处理',
    listRouter: '/purchase/billing/cost/list/3'
  },
  '5404': {
    billType: '54',
    billName: '费用单',
    tabId: '5404',
    tabName: '待确认',
    listRouter: '/purchase/billing/cost/list/2'
  },
  '6001': {
    billType: '60',
    billName: '预付款',
    tabId: '6001',
    tabName: '待发布',
    listRouter: '/purchase/payment/advance/list/2'
  },
  '6002': {
    billType: '60',
    billName: '预付款',
    tabId: '6002',
    tabName: '已撤回',
    listRouter: '/purchase/payment/advance/list'
  },
  '6101': {
    billType: '61',
    billName: '付款申请',
    tabId: '6101',
    tabName: '待发布',
    listRouter: '/purchase/payment/apply/list'
  },
  '6102': {
    billType: '61',
    billName: '付款申请',
    tabId: '6102',
    tabName: '已撤回',
    listRouter: '/purchase/payment/apply/list'
  },
  '6103': {
    billType: '61',
    billName: '付款申请',
    tabId: '6103',
    tabName: '待审批',
    listRouter: '/purchase/payment/apply/list'
  },
  '8501': {
    billType: '85',
    billName: '提前付款申请',
    tabId: '8501',
    tabName: '待审核',
    listRouter: '/purchase/payment/early-pymt-apply/list'
  },
  '8502': {
    billType: '85',
    billName: '提前付款申请',
    tabId: '8502',
    tabName: '待传协议',
    listRouter: '/purchase/payment/early-pymt-apply/list'
  },
  '6201': {
    billType: '62',
    billName: '付款计划',
    tabId: '6201',
    tabName: '待支付',
    listRouter: '/purchase/payment/plan'
  },
  '6202': {
    billType: '62',
    billName: '付款计划',
    tabId: '6202',
    tabName: '待审核',
    listRouter: '/purchase/payment/plan/1'
  },
  '6203': {
    billType: '62',
    billName: '付款计划',
    tabId: '6203',
    tabName: '逾期支付',
    listRouter: '/purchase/payment/plan/2'
  },
  '6401': {
    billType: '64',
    billName: '付款单',
    tabId: '6401',
    tabName: '待发布',
    listRouter: '/purchase/payment/order/list'
  },
  '6402': {
    billType: '64',
    billName: '付款单',
    tabId: '6402',
    tabName: '已撤回',
    listRouter: '/purchase/payment/order/list'
  },
  '6403': {
    billType: '64',
    billName: '付款单',
    tabId: '6403',
    tabName: '待审批',
    listRouter: '/purchase/payment/order/list/1'
  },
  '6801': {
    billType: '68',
    billName: '金融凭证',
    tabId: '6801',
    tabName: '待签收',
    listRouter: '/purchase/billing/acceptance/list/1'
  },
  '1020': {
    billType: '10A',
    billName: '客户订单',
    tabId: '1020',
    tabName: '待答交',
    listRouter: '/sale/customer/list/1'
  },
  '1021': {
    billType: '10A',
    billName: '客户订单',
    tabId: '1021',
    tabName: '答交退回',
    listRouter: '/sale/customer/list/4'
  },
  '1022': {
    billType: '10A',
    billName: '客户订单',
    tabId: '1022',
    tabName: '待签章',
    listRouter: '/sale/customer/list/7'
  },
  '1023': {
    billType: '10A',
    billName: '客户订单',
    tabId: '1023',
    tabName: '送货不足',
    listRouter: '/sale/customer/list'
  },
  '1024': {
    billType: '10A',
    billName: '客户订单',
    tabId: '1024',
    tabName: '逾期未送货',
    listRouter: '/sale/customer/list'
  },
  '1025': {
    billType: '10A',
    billName: '客户订单',
    tabId: '1025',
    tabName: '答交待确认',
    listRouter: '/sale/customer/list/3'
  },
  '1120': {
    billType: '11A',
    billName: '客户变更单',
    tabId: '1120',
    tabName: '待答交',
    listRouter: '/sale/customer/change/list'
  },
  '1520': {
    billType: '15A',
    billName: '送货不良记录',
    tabId: '1520',
    tabName: '待确认',
    listRouter: '/sale/customer/iqc/list/1'
  },
  '1620': {
    billType: '16A',
    billName: '客户交料通知',
    tabId: '1620',
    tabName: '待答交',
    listRouter: '/sale/delivery-change/list/7'
  },
  '1621': {
    billType: '16A',
    billName: '客户交料通知',
    tabId: '1621',
    tabName: '答交退回',
    listRouter: '/sale/delivery-change/list/2'
  },
  '1622': {
    billType: '16A',
    billName: '客户交料通知',
    tabId: '1622',
    tabName: '答交待确认',
    listRouter: '/sale/delivery-change/list/1'
  },
  '2220': {
    billType: '22A',
    billName: '送货通知',
    tabId: '2220',
    tabName: '待发布',
    listRouter: '/sale/delivery/note/list/2'
  },
  // '2221': {
  //   billType: '22A',
  //   billName: '送货通知',
  //   tabId: '2221',
  //   tabName: '待签收',
  //   listRouter: '/sale/delivery/note/list/3'
  // },
  '2222': {
    billType: '22A',
    billName: '送货通知',
    tabId: '2222',
    tabName: '申请待确认',
    listRouter: '/sale/delivery/note/list/4'
  },
  '2620': {
    billType: '26A',
    billName: '延迟送货申请',
    tabId: '2620',
    tabName: '待发布',
    listRouter: '/sale/delivery-delay/list/1'
  },
  '2621': {
    billType: '26A',
    billName: '延迟送货申请',
    tabId: '2621',
    tabName: '退回',
    listRouter: '/sale/delivery-delay/list/3'
  },
  '2622': {
    billType: '26A',
    billName: '延迟送货申请',
    tabId: '2622',
    tabName: '待确认',
    listRouter: '/sale/delivery-delay/list/2'
  },
  '3020': {
    billType: '30A',
    billName: '客户交货排程',
    tabId: '3020',
    tabName: '待答交',
    listRouter: '/sale/plan/schedule/list/1'
  },
  '3021': {
    billType: '30A',
    billName: '客户交货排程',
    tabId: '3021',
    tabName: '答交退回',
    listRouter: '/sale/plan/schedule/list/3'
  },
  '3022': {
    billType: '30A',
    billName: '客户交货排程',
    tabId: '3022',
    tabName: '答交待确认',
    listRouter: '/sale/plan/schedule/list/2'
  },
  '3320': {
    billType: '33A',
    billName: '物料准入报告',
    tabId: '3320',
    tabName: '待回复',
    listRouter: '/sale/customer/buyoff-report/list/2'
  },
  '3321': {
    billType: '33A',
    billName: '物料准入报告',
    tabId: '3321',
    tabName: '待审核',
    listRouter: '/sale/customer/buyoff-report/list/3'
  },
  '4020': {
    billType: '40A',
    billName: '客户合同',
    tabId: '4020',
    tabName: '待确认',
    listRouter: '/sale/customer/contract/list'
  },
  '4021': {
    billType: '40A',
    billName: '客户合同',
    tabId: '4021',
    tabName: '待签章',
    listRouter: '/sale/customer/contract/list'
  },
  '4120': {
    billType: '41A',
    billName: '客户资质',
    tabId: '4120',
    tabName: '待回复',
    listRouter: '/sale/customer/qualification/list/2'
  },
  '4121': {
    billType: '41A',
    billName: '客户资质',
    tabId: '4121',
    tabName: '临近到期',
    listRouter: '/sale/customer/qualification/list/3'
  },
  '4122': {
    billType: '41A',
    billName: '客户资质',
    tabId: '4122',
    tabName: '待审核',
    listRouter: '/sale/customer/qualification/list'
  },
  '4320': {
    billType: '43A',
    billName: '违约/索赔通知',
    tabId: '4320',
    tabName: '待确认',
    listRouter: '/sale/customer/penalty-notice/list/1'
  },
  '4620': {
    billType: '46A',
    billName: '项目预询单',
    tabId: '4620',
    tabName: '待回复',
    listRouter: '/sale/inquiry/project/pre-inquiry/list'
  },
  '4920': {
    billType: '49A',
    billName: '订单直运计划',
    tabId: '4920',
    tabName: '待答交',
    listRouter: '/sale/plan/tpp/board/2'
  },
  '4921': {
    billType: '49A',
    billName: '订单直运计划',
    tabId: '4921',
    tabName: '待送货',
    listRouter: '/sale/plan/tpp/board/1'
  },
  '4922': {
    billType: '49A',
    billName: '订单直运计划',
    tabId: '4922',
    tabName: '送货不足',
    listRouter: '/sale/plan/tpp/board'
  },
  '4923': {
    billType: '49A',
    billName: '订单直运计划',
    tabId: '4923',
    tabName: '逾期未送货',
    listRouter: '/sale/plan/tpp/board'
  },
  '5120': {
    billType: '51A',
    billName: '客户询价招标',
    tabId: '5120',
    tabName: '待报价',
    listRouter: '/sale/inquiry/prod/list/1'
  },
  '5121': {
    billType: '51A',
    billName: '客户询价招标',
    tabId: '5121',
    tabName: '报价退回',
    listRouter: '/sale/inquiry/prod/list/4'
  },
  '5122': {
    billType: '51A',
    billName: '客户询价招标',
    tabId: '5122',
    tabName: '待确认',
    listRouter: '/sale/inquiry/prod/list/2'
  },
  '5220': {
    billType: '52A',
    billName: '客户对账单',
    tabId: '5220',
    tabName: '待发布',
    listRouter: '/sale/billing/statement/list/1'
  },
  '5221': {
    billType: '52A',
    billName: '客户对账单',
    tabId: '5221',
    tabName: '待签章',
    listRouter: '/sale/billing/statement/list'
  },
  '5222': {
    billType: '52A',
    billName: '客户对账单',
    tabId: '5222',
    tabName: '待确认',
    listRouter: '/sale/billing/statement/list/2'
  },
  '5320': {
    billType: '53A',
    billName: '客户发票单',
    tabId: '5320',
    tabName: '待发布',
    listRouter: '/sale/billing/invoice/list'
  },
  '5321': {
    billType: '53A',
    billName: '客户发票单',
    tabId: '5321',
    tabName: '发票退回',
    listRouter: '/sale/billing/invoice/list/1'
  },
  '5322': {
    billType: '53A',
    billName: '客户发票单',
    tabId: '5322',
    tabName: '待确认',
    listRouter: '/sale/billing/invoice/list/2'
  },
  '5420': {
    billType: '54A',
    billName: '客户费用单',
    tabId: '5420',
    tabName: '待确认',
    listRouter: '/sale/billing/cost/list/2'
  },
  '5520': {
    billType: '55A',
    billName: '客户竞价',
    tabId: '5520',
    tabName: '待竞价',
    listRouter: '/sale/inquiry/bid/list/1'
  },
  '5521': {
    billType: '55A',
    billName: '客户竞价',
    tabId: '5521',
    tabName: '竞价中',
    listRouter: '/sale/inquiry/bid/list/2'
  },
  '5522': {
    billType: '55A',
    billName: '客户竞价',
    tabId: '5522',
    tabName: '待公布',
    listRouter: '/sale/inquiry/bid/list/3'
  },
  '6120': {
    billType: '61A',
    billName: '付款申请',
    tabId: '6120',
    tabName: '待发布',
    listRouter: '/sale/cust-payment/apply/list'
  },
  '6121': {
    billType: '61A',
    billName: '付款申请',
    tabId: '6121',
    tabName: '申请退回',
    listRouter: '/sale/cust-payment/apply/list'
  },
  '6122': {
    billType: '61A',
    billName: '付款申请',
    tabId: '6122',
    tabName: '待确认',
    listRouter: '/sale/cust-payment/apply/list'
  },
  '6920': {
    billType: '69A',
    billName: '客户ECN报告',
    tabId: '6920',
    tabName: '待发布',
    listRouter: '/sale/ecn/list'
  },
  '6921': {
    billType: '69A',
    billName: '客户ECN报告',
    tabId: '6921',
    tabName: '报告退回',
    listRouter: '/sale/ecn/list/4'
  },
  '6922': {
    billType: '69A',
    billName: '客户ECN报告',
    tabId: '6922',
    tabName: '待确认',
    listRouter: '/sale/ecn/list'
  },
  '7120': {
    billType: '71A',
    billName: '项目招标',
    tabId: '7120',
    tabName: '待投标',
    listRouter: '/sale/inquiry/project/ifb/list'
  },
  '7121': {
    billType: '71A',
    billName: '项目招标',
    tabId: '7121',
    tabName: '待评审',
    listRouter: '/sale/inquiry/project/ifb/list'
  },
  '7122': {
    billType: '71A',
    billName: '项目招标',
    tabId: '7122',
    tabName: '待评标',
    listRouter: '/sale/inquiry/project/ifb/list'
  },
  '7320': {
    billType: '73A',
    billName: '客户准入评估',
    tabId: '7320',
    tabName: '待回复',
    listRouter: '/sale/customer/assessment-report/list/2'
  },
  '7321': {
    billType: '73A',
    billName: '客户准入评估',
    tabId: '7321',
    tabName: '待审核',
    listRouter: '/sale/customer/assessment-report/list/3'
  },
  '7820': {
    billType: '78A',
    billName: '客户工装',
    tabId: '7820',
    tabName: '待转出',
    listRouter: '/sale/tooling/transfer/list/1'
  },
  '7821': {
    billType: '78A',
    billName: '客户工装',
    tabId: '7821',
    tabName: '待接收',
    listRouter: '/sale/tooling/transfer/list/2'
  },
  '7920': {
    billType: '79A',
    billName: '申诉单',
    tabId: '7920',
    tabName: '待发布',
    listRouter: '/sale/customer/my-complaint/list'
  },
  '7921': {
    billType: '79A',
    billName: '申诉单',
    tabId: '7921',
    tabName: '待确认',
    listRouter: '/sale/customer/my-complaint/list'
  },
  // '8220': {
  //   billType: '82A',
  //   billName: '客户物料图纸变更',
  //   tabId: '8220',
  //   tabName: '待确认',
  //   listRouter: '/sale/customer/prod-graph/list/1'
  // },
  '8320': {
    billType: '83A',
    billName: '客户改善报告',
    tabId: '8320',
    tabName: '待回复',
    listRouter: '/sale/customer/my-improvement-report/list/1'
  },
  '8321': {
    billType: '83A',
    billName: '客户改善报告',
    tabId: '8321',
    tabName: '待审核',
    listRouter: '/sale/customer/my-improvement-report/list/2'
  },
  '8420': {
    billType: '84A',
    billName: '客户竞价',
    tabId: '8420',
    tabName: '待竞价',
    listRouter: '/sale/inquiry/bid/list/1'
  },
  '8421': {
    billType: '84A',
    billName: '客户竞价',
    tabId: '8421',
    tabName: '竞价中',
    listRouter: '/sale/inquiry/bid/list/2'
  },
  '8422': {
    billType: '84A',
    billName: '客户竞价',
    tabId: '8422',
    tabName: '待公布',
    listRouter: '/sale/inquiry/bid/list/3'
  },
  '8520': {
    billType: '85A',
    billName: '提前付款申请',
    tabId: '8520',
    tabName: '待传协议',
    listRouter: '/sale/cust-payment/early-pymt-apply/list'
  },
  '8521': {
    billType: '85A',
    billName: '提前付款申请',
    tabId: '8521',
    tabName: '待发布',
    listRouter: '/sale/cust-payment/early-pymt-apply/list'
  },
  '8522': {
    billType: '85A',
    billName: '提前付款申请',
    tabId: '8522',
    tabName: '待确认',
    listRouter: '/sale/cust-payment/early-pymt-apply/list'
  },
  '10120': {
    billType: '101A',
    billName: '客户问卷',
    tabId: '10120',
    tabName: '待回复',
    listRouter: '/sale/customer/questionnaire/list'
  },
  // '11020': {
  //   billType: '110A',
  //   billName: '客户通知',
  //   tabId: '11020',
  //   tabName: '待确认',
  //   listRouter: '/sale/customer/notice/list'
  // },
  '1701': {
    billType: '17',
    billName: '工装移转',
    tabId: '1701',
    tabName: '待转出',
    tradeType: 1,
    listRouter: '/purchase/tooling/transfer/list/1'
  },
  '1702': {
    billType: '17',
    billName: '工装移转',
    tabId: '1702',
    tabName: '待接收',
    tradeType: 1,
    listRouter: '/purchase/tooling/transfer/list/3'
  },
  '1703': {
    billType: '17',
    billName: '工装移转',
    tabId: '1703',
    tabName: '转出待接收',
    tradeType: 1,
    listRouter: '/purchase/tooling/transfer/list/2'
  },
  '2301': {
    billType: '23',
    billName: '核价单',
    tabId: '2301',
    tabName: '待审核',
    tradeType: 1,
    listRouter: '/purchase/pricing/list/1'
  },
  '2901': {
    billType: '29',
    billName: '供应商',
    tabId: '2901',
    tabName: '邀约中',
    tradeType: 1,
    listRouter: '/purchase/supplier/list/1'
  },
  '3301': {
    billType: '33',
    billName: '物料准入报告',
    tabId: '3301',
    tabName: '待发布',
    tradeType: 1,
    listRouter: '/purchase/supplier/buyoff-report/list'
  },
  '3302': {
    billType: '33',
    billName: '物料准入报告',
    tabId: '3302',
    tabName: '待评分',
    tradeType: 1,
    listRouter: '/purchase/supplier/buyoff-report/list/1'
  },
  '3303': {
    billType: '33',
    billName: '物料准入报告',
    tabId: '3303',
    tabName: '待回复',
    tradeType: 1,
    listRouter: '/purchase/supplier/buyoff-report/list/2'
  },
  '4001': {
    billType: '40',
    billName: '供应商合同',
    tabId: '4001',
    tabName: '待签署',
    tradeType: 1,
    listRouter: '/purchase/supplier/contract/list/1'
  },
  '4003': {
    billType: '40',
    billName: '供应商合同',
    tabId: '4003',
    tabName: '已失效',
    tradeType: 1,
    listRouter: '/purchase/supplier/contract/list/3'
  },
  // '4101': {
  //   billType: '41',
  //   billName: '供应商资质',
  //   tabId: '4101',
  //   tabName: '待确认',
  //   tradeType: 1,
  //   listRouter: '/purchase/supplier/qualification/list/3'
  // },
  // '4102': {
  //   billType: '41',
  //   billName: '供应商资质',
  //   tabId: '4102',
  //   tabName: '待回复',
  //   tradeType: 1,
  //   listRouter: '/purchase/supplier/qualification/list/4'
  // },
  '4104': {
    billType: '41',
    billName: '供应商资质',
    tabId: '4104',
    tabName: '已过期',
    tradeType: 1,
    listRouter: '/purchase/supplier/qualification/list/2'
  },
  '4301': {
    billType: '43',
    billName: '违约/索赔通知',
    tabId: '4301',
    tabName: '待发布',
    tradeType: 1,
    listRouter: '/purchase/supplier/penalty-notice/list'
  },
  '4302': {
    billType: '43',
    billName: '违约/索赔通知',
    tabId: '4302',
    tabName: '待确认',
    tradeType: 1,
    listRouter: '/purchase/supplier/penalty-notice/list/1'
  },
  '4501': {
    billType: '45',
    billName: '供应商信息变更',
    tabId: '4501',
    tabName: '待确认',
    tradeType: 1,
    listRouter: '/purchase/supplier/info-change/list/1'
  },
  '4520': {
    billType: '45A',
    billName: '企业信息变更',
    tabId: '4520',
    tabName: '待发布',
    tradeType: 2,
    listRouter: '/sale/customer/my-info-change/list'
  },
  '4521': {
    billType: '45A',
    billName: '企业信息变更',
    tabId: '4521',
    tabName: '待确认',
    tradeType: 2,
    listRouter: '/sale/customer/my-info-change/list'
  },
  '4601': {
    billType: '46',
    billName: '询价需求池',
    tabId: '4601',
    tabName: '待发布',
    tradeType: 1,
    listRouter: '/purchase/inquiry/inner/board'
  },
  '4602': {
    billType: '46',
    billName: '询价需求池',
    tabId: '4602',
    tabName: '评审中',
    tradeType: 1,
    listRouter: '/purchase/inquiry/inner/board'
  },
  '4603': {
    billType: '46',
    billName: '询价需求池',
    tabId: '4603',
    tabName: '待回复',
    tradeType: 1,
    listRouter: '/purchase/inquiry/inner/board/3'
  },
  '5001': {
    billType: '50',
    billName: '询价单',
    tabId: '5001',
    tabName: '待发布',
    tradeType: 1,
    listRouter: '/purchase/inquiry/prod/list'
  },
  '5002': {
    billType: '50',
    billName: '询价单',
    tabId: '5002',
    tabName: '已撤回',
    tradeType: 1,
    listRouter: '/purchase/inquiry/prod/list'
  },
  '5020': {
    billType: '50A',
    billName: '客户询价招标',
    tabId: '5020',
    tabName: '待报价',
    tradeType: 2,
    listRouter: '/sale/inquiry/prod/list/1'
  },
  '5021': {
    billType: '50A',
    billName: '客户询价招标',
    tabId: '5021',
    tabName: '报价退回',
    tradeType: 2,
    listRouter: '/sale/inquiry/prod/list/4'
  },
  '5022': {
    billType: '50A',
    billName: '客户询价招标',
    tabId: '5022',
    tabName: '待确认',
    tradeType: 2,
    listRouter: '/sale/inquiry/prod/list/2'
  },
  // '5050': {
  //   billType: '50B',
  //   billName: '询价需求池',
  //   tabId: '5050',
  //   tabName: '待询价',
  //   tradeType: 1,
  //   listRouter: '/purchase/inquiry/inner/board/1'
  // },
  // '5051': {
  //   billType: '50B',
  //   billName: '询价需求池',
  //   tabId: '5051',
  //   tabName: '待回复',
  //   tradeType: 1,
  //   listRouter: '/purchase/inquiry/inner/board/3'
  // },
  '5103': {
    billType: '51',
    billName: '供应商申诉',
    tabId: '5103',
    tabName: '待处理',
    tradeType: 1,
    listRouter: '/purchase/supplier/complaint/list/1'
  },
  '5501': {
    billType: '55',
    billName: '供应商竞价',
    tabId: '5501',
    tabName: '待发布',
    tradeType: 1,
    listRouter: '/purchase/inquiry/bid/list'
  },
  '5502': {
    billType: '55',
    billName: '供应商竞价',
    tabId: '5502',
    tabName: '待竞价',
    tradeType: 1,
    listRouter: '/purchase/inquiry/bid/list/1'
  },
  '5503': {
    billType: '55',
    billName: '供应商竞价',
    tabId: '5503',
    tabName: '比价中',
    tradeType: 1,
    listRouter: '/purchase/inquiry/bid/list/3'
  },
  '5504': {
    billType: '55',
    billName: '供应商竞价',
    tabId: '5504',
    tabName: '竞价中',
    tradeType: 1,
    listRouter: '/purchase/inquiry/bid/list/2'
  },
  '5901': {
    billType: '59',
    billName: '比价单',
    tabId: '5901',
    tabName: '待转核价',
    tradeType: 1,
    listRouter: '/purchase/inquiry/quote-compare/list'
  },
  '5902': {
    billType: '59',
    billName: '比价单',
    tabId: '5902',
    tabName: '比价中',
    tradeType: 1,
    listRouter: '/purchase/inquiry/quote-compare/list/1'
  },
  '6901': {
    billType: '69',
    billName: '供应商ECN报告',
    tabId: '6901',
    tabName: '待RD工程',
    tradeType: 1,
    listRouter: '/purchase/ecn/list/5'
  },
  '6902': {
    billType: '69',
    billName: '供应商ECN报告',
    tabId: '6902',
    tabName: '待质量管理',
    tradeType: 1,
    listRouter: '/purchase/ecn/list/1'
  },
  '6903': {
    billType: '69',
    billName: '供应商ECN报告',
    tabId: '6903',
    tabName: '待IQC',
    tradeType: 1,
    listRouter: '/purchase/ecn/list/2'
  },
  '6904': {
    billType: '69',
    billName: '供应商ECN报告',
    tabId: '6904',
    tabName: '已退回',
    tradeType: 1,
    listRouter: '/purchase/ecn/list/4'
  },
  '7101': {
    billType: '71',
    billName: '项目招标',
    tabId: '7101',
    tabName: '待发布',
    tradeType: 1,
    listRouter: '/purchase/inquiry/project/ifb/list'
  },
  '7102': {
    billType: '71',
    billName: '项目招标',
    tabId: '7102',
    tabName: '待立项',
    tradeType: 1,
    listRouter: '/purchase/inquiry/project/ifb/list/1'
  },
  '7103': {
    billType: '71',
    billName: '项目招标',
    tabId: '7103',
    tabName: '评标中',
    tradeType: 1,
    listRouter: '/purchase/inquiry/project/ifb/list/3'
  },
  '7104': {
    billType: '71',
    billName: '项目招标',
    tabId: '7104',
    tabName: '评标结束',
    tradeType: 1,
    listRouter: '/purchase/inquiry/project/ifb/list/4'
  },
  '7105': {
    billType: '71',
    billName: '项目招标',
    tabId: '7105',
    tabName: '报价中',
    tradeType: 1,
    listRouter: '/purchase/inquiry/project/ifb/list/2'
  },
  '7301': {
    billType: '73',
    billName: '供应商评价',
    tabId: '7301',
    tabName: '待评审',
    tradeType: 1,
    listRouter: '/purchase/supplier/annual-assessment-report/list/2'
  },
  '7302': {
    billType: '73',
    billName: '供应商评价',
    tabId: '7302',
    tabName: '待回复',
    tradeType: 1,
    listRouter: '/purchase/supplier/annual-assessment-report/list/1'
  },
  '7401': {
    billType: '74',
    billName: '内部商城引入单',
    tabId: '7401',
    tabName: '待发布',
    tradeType: 1,
    listRouter: '/purchase/mall/introduce-list'
  },
  '7402': {
    billType: '74',
    billName: '内部商城引入单',
    tabId: '7402',
    tabName: '待审批',
    tradeType: 1,
    listRouter: '/purchase/mall/introduce-list/1'
  },
  '7403': {
    billType: '74',
    billName: '内部商城引入单',
    tabId: '7403',
    tabName: '选品中',
    tradeType: 1,
    listRouter: '/purchase/mall/introduce-list'
  },
  '7801': {
    billType: '78',
    billName: '工装档案',
    tabId: '7801',
    tabName: '未发布',
    tradeType: 1,
    listRouter: '/purchase/tooling/info/list/1'
  },
  '7802': {
    billType: '78',
    billName: '工装档案',
    tabId: '7802',
    tabName: '待返费',
    tradeType: 1,
    listRouter: '/purchase/tooling/info/list/3'
  },
  '7901': {
    billType: '79',
    billName: '供应商申诉',
    tabId: '7901',
    tabName: '待处理',
    tradeType: 1,
    listRouter: '/purchase/supplier/complaint/list/1'
  },
  // '8201': {
  //   billType: '82',
  //   billName: '物料图纸变更',
  //   tabId: '8201',
  //   tabName: '待发布',
  //   tradeType: 1,
  //   listRouter: '/purchase/supplier/prod-graph/list'
  // },
  // '8202': {
  //   billType: '82',
  //   billName: '物料图纸变更',
  //   tabId: '8202',
  //   tabName: '待确认',
  //   tradeType: 1,
  //   listRouter: '/purchase/supplier/prod-graph/list/1'
  // },
  '8301': {
    billType: '83',
    billName: '改善报告',
    tabId: '8301',
    tabName: '待发布',
    tradeType: 1,
    listRouter: '/purchase/supplier/improvement-report/list'
  },
  '8302': {
    billType: '83',
    billName: '改善报告',
    tabId: '8302',
    tabName: '待审核',
    tradeType: 1,
    listRouter: '/purchase/supplier/improvement-report/list/2'
  },
  '8303': {
    billType: '83',
    billName: '改善报告',
    tabId: '8303',
    tabName: '待回复',
    tradeType: 1,
    listRouter: '/purchase/supplier/improvement-report/list/1'
  },
  '8401': {
    billType: '84',
    billName: '多物料竞价',
    tabId: '8401',
    tabName: '待发布',
    tradeType: 1,
    listRouter: '/purchase/inquiry/bid-multi/list'
  },
  '8402': {
    billType: '84',
    billName: '多物料竞价',
    tabId: '8402',
    tabName: '待竞价',
    tradeType: 1,
    listRouter: '/purchase/inquiry/bid-multi/list/1'
  },
  '8403': {
    billType: '84',
    billName: '多物料竞价',
    tabId: '8403',
    tabName: '比价中',
    tradeType: 1,
    listRouter: '/purchase/inquiry/bid-multi/list/3'
  },
  '8404': {
    billType: '84',
    billName: '多物料竞价',
    tabId: '8404',
    tabName: '竞价中',
    tradeType: 1,
    listRouter: '/purchase/inquiry/bid-multi/list/2'
  },
  '8601': {
    billType: '86',
    billName: '物料资质',
    tabId: '8601',
    tabName: '待确认',
    tradeType: 1,
    listRouter: '/management/basic-data/qualification/list/3'
  },
  '8602': {
    billType: '86',
    billName: '物料资质',
    tabId: '8602',
    tabName: '待回复',
    tradeType: 1,
    listRouter: '/management/basic-data/qualification/list/4'
  },
  '9101': {
    billType: '91',
    billName: '进货折让单',
    tabId: '9101',
    tabName: '待发布',
    tradeType: 1,
    listRouter: '/purchase/billing/debit/list'
  },
  '9102': {
    billType: '91',
    billName: '进货折让单',
    tabId: '9102',
    tabName: '待确认',
    tradeType: 1,
    listRouter: '/purchase/billing/debit/list/1'
  },
  '9201': {
    billType: '92',
    billName: '索样通知单',
    tabId: '9201',
    tabName: '待发布',
    tradeType: 1,
    listRouter: '/purchase/order/sample/list'
  },
  '9202': {
    billType: '92',
    billName: '索样通知单',
    tabId: '9202',
    tabName: '差异待处理',
    tradeType: 1,
    listRouter: '/purchase/order/sample/list'
  },
  '9203': {
    billType: '92',
    billName: '索样通知单',
    tabId: '9203',
    tabName: '待答交',
    tradeType: 1,
    listRouter: '/purchase/order/sample/list'
  },
  '9204': {
    billType: '92',
    billName: '索样通知单',
    tabId: '9204',
    tabName: '答交退回',
    tradeType: 1,
    listRouter: '/purchase/order/sample/list'
  },
  '10101': {
    billType: '101',
    billName: '供应商问卷',
    tabId: '10101',
    tabName: '待发布',
    tradeType: 1,
    listRouter: '/purchase/supplier/questionnaire/list'
  },
  '10102': {
    billType: '101',
    billName: '供应商问卷',
    tabId: '10102',
    tabName: '待回复',
    tradeType: 1,
    listRouter: '/purchase/supplier/questionnaire/list'
  },
  '11001': {
    billType: '110',
    billName: '供应商通知',
    tabId: '11001',
    tabName: '待发布',
    tradeType: 1,
    listRouter: '/purchase/supplier/notice/list'
  },
  '11002': {
    billType: '110',
    billName: '供应商通知',
    tabId: '11002',
    tabName: '待确认',
    tradeType: 1,
    listRouter: '/purchase/supplier/notice/list'
  },
  '8701': {
    billType: '87',
    billName: '潜在供应商',
    tabId: '8701',
    tabName: '待审核',
    tradeType: 1,
    listRouter: '/purchase/sourcing/list/5'
  },
  '8702': {
    billType: '87',
    billName: '潜在供应商',
    tabId: '8702',
    tabName: '申请中',
    tradeType: 1,
    listRouter: '/purchase/sourcing/list/2'
  },
  '8703': {
    billType: '87',
    billName: '潜在供应商',
    tabId: '8703',
    tabName: '邀约中',
    tradeType: 1,
    listRouter: '/purchase/sourcing/list/1'
  }
};

/**
 * 单据类型映射
 * 单据billType对应的单据状态mainKey
 *
 */
export const BILLTYPE_MAP = {
  '10': {
    billName: '采购单',
    mainKey: 'B02_NPo_Status'
  },
  '11': {
    billName: '采购变更单',
    mainKey: 'B02_co_Status'
  },
  '12': {
    billName: '收货单',
    mainKey: 'B02_Ro_Status'
  },
  '13': {
    billName: '入库单',
    mainKey: 'B02_Sto_Status'
  },
  '14': {
    billName: '退货单',
    mainKey: 'B02_Rto_Status'
  },
  '15': {
    billName: '来料检验单',
    mainKey: 'B02_Verify_Status'
  },
  '16': {
    billName: '交料通知单',
    mainKey: 'B02_Acn_Status'
  },
  '17': {
    billName: '工装转移单',
    mainKey: 'B02_ToolsTransfer_Status'
  },
  '18': {
    billName: '样品追踪单',
    mainKey: 'B02_Sample_Status'
  },
  '19': {
    billName: '请购单',
    mainKey: 'B02_Requisition_Order_Status'
  },
  '22': {
    billName: '送货单',
    mainKey: 'B02_Dn_Status'
  },
  '23': {
    billName: '核价单',
    mainKey: 'B02_Price_Order_Status'
  },
  '26': {
    billName: '延迟送货申请',
    mainKey: 'B02_Acn_Status'
  },
  '27': {
    billName: '8D报告',
    mainKey: 'B02_Product8D_Report_Status'
  },
  '28': {
    billName: '物流竞价',
    mainKey: 'B02_Bid_Status'
  },
  '29': {
    billName: '正式供应商',
    mainKey: 'B02_vendor_Invite_Status'
  },
  '30': {
    billName: '供应计划排程',
    mainKey: 'B02_Sch_Batch_Status'
  },
  '31': {
    billName: '生产计划',
    mainKey: ''
  },
  '32': {
    billName: '预检申请单',
    mainKey: 'B02_Pre_Verify_Apply_Status'
  },
  '33': {
    billName: '物料准入报告',
    mainKey: 'B02_Material_Report_Status'
  },
  '34': {
    billName: '质量目标追踪',
    mainKey: 'B02_Quality_Track_Status'
  },
  '35': {
    billName: '销售_变更单',
    mainKey: ''
  },
  '36': {
    billName: '出货_出库单',
    mainKey: ''
  },
  '37': {
    billName: '销售_退货单',
    mainKey: ''
  },
  '38': {
    billName: '销售_对账单',
    mainKey: ''
  },
  '39': {
    billName: '销售_发票单',
    mainKey: ''
  },
  '40': {
    billName: '供应商合同',
    mainKey: 'B02_Contract_Status'
  },
  '41': {
    billName: '供应商资质',
    mainKey: 'B02_Certificates_Status'
  },
  '42': {
    billName: '资源申请单',
    mainKey: 'B02_Res_Pool_Status'
  },
  '43': {
    billName: '供应商处罚通知',
    mainKey: 'B02_punish_Status'
  },
  '44': {
    billName: '供应商清退',
    mainKey: 'B02_eliminate_vendor_notice_Status'
  },
  '45': {
    billName: '供应商信息变更',
    mainKey: 'B02_Company_Changed_Status'
  },
  '46': {
    billName: '项目预询单',
    mainKey: 'B02_Prepare_Project_Status'
  },
  '47': {
    billName: '项目预询报价单',
    mainKey: ''
  },
  '48': {
    billName: '核价失效单',
    mainKey: ''
  },
  '49': {
    billName: '订单直运看板',
    mainKey: 'B02_Direct_Status'
  },
  '50': {
    billName: '物料询价招标',
    mainKey: 'B02_Inquiry_Status'
  },
  '51': {
    billName: '报价',
    mainKey: 'B02_Inquiry_Status'
  },
  '52': {
    billName: '供应商对账单',
    mainKey: 'B02_Reco_Status'
  },
  '53': {
    billName: '供应商发票',
    mainKey: 'B02_Inv_Status'
  },
  '54': {
    billName: '供应商费用单',
    mainKey: 'B02_Cost_Status'
  },
  '55': {
    billName: '供应商竞价',
    mainKey: 'B02_Bid_Status'
  },
  '56': {
    billName: '竞价_预报价单',
    mainKey: ''
  },
  '57': {
    billName: '转移单',
    mainKey: ''
  },
  '58': {
    billName: '商机管理',
    mainKey: 'B02_Opportunity_Status'
  },
  '59': {
    billName: '比价单',
    mainKey: 'B02_Inquiry_Status'
  },
  '60': {
    billName: '预付款单',
    mainKey: 'B02_PrepayOrder_status'
  },
  '61': {
    billName: '付款申请单',
    mainKey: 'B_CompPlan_Status'
  },
  '62': {
    billName: '付款计划',
    mainKey: ''
  },
  '63': {
    billName: '支付申请',
    mainKey: ''
  },
  '64': {
    billName: '付款单',
    mainKey: 'B02_ReceiptOrder_Status'
  },
  '65': {
    billName: '预付退款单',
    mainKey: ''
  },
  '66': {
    billName: '预付结转单',
    mainKey: ''
  },
  '67': {
    billName: '销售订单',
    mainKey: 'B02_So_Status'
  },
  '68': {
    billName: '金融票据',
    mainKey: 'B02_Fnc_Platform_Order_Status'
  },
  '69': {
    billName: 'ECN通知',
    mainKey: 'B02_Ecn_Report_Status'
  },
  '70': {
    billName: '需求单',
    mainKey: 'B02_Inner_Inquiry_Status'
  },
  '71': {
    billName: '项目招标单',
    mainKey: 'B02_Project_Bidding_Status'
  },
  '72': {
    billName: '项目投标单',
    mainKey: ''
  },
  '73': {
    billName: '供应商准入评估',
    mainKey: 'B02_Admission_Report_Status'
  },
  '74': {
    billName: '内部商城引入单',
    mainKey: 'B02_Introduce_Status'
  },
  '76': {
    billName: '采购验收单',
    mainKey: 'B02_Po_Assets_Acceptance_Status'
  },
  '77': {
    billName: '送样通知单',
    mainKey: 'B02_Sample_Dn_Status'
  },
  '78': {
    billName: '工装档案',
    mainKey: 'B02_ToolsInfo_Status'
  },
  '79': {
    billName: '供应商申诉单',
    mainKey: 'B2b_appeal_order_status'
  },
  '82': {
    billName: '物料图纸变更',
    mainKey: 'B2b_prod_graph_change_status'
  },
  '83': {
    billName: '改善报告',
    mainKey: 'B2b_improve_report_status'
  },
  '84': {
    billName: '多物料竞价单',
    mainKey: 'B02_Bid_Status'
  },
  '85': {
    billName: '提前付款申请',
    mainKey: 'B02_Pay_Apply_status'
  },
  '86': {
    billName: '物料资质',
    mainKey: 'B02_Certificates_Status'
  },
  '87': {
    billName: '潜在供应商',
    mainKey: 'B02_Pot_Vendor_Apply_Status'
  },
  '91': {
    billName: '折让订单',
    mainKey: 'B02_Reco_Status'
  },
  '92': {
    billName: '索样单',
    mainKey: 'B2b_CableSample_Order_Status'
  },
  '94': {
    billName: '物料停产报告',
    mainKey: 'B02_Stop_Product_Report_Status'
  },
  '101': {
    billName: '问卷调查',
    mainKey: ''
  },
  '103': {
    billName: '物料替代维护',
    mainKey: ''
  },
  '104': {
    billName: '企业物料',
    mainKey: ''
  },
  '105': {
    billName: '企业物料附件',
    mainKey: ''
  },
  '107': {
    billName: '供应商绩效',
    mainKey: ''
  },
  '110': {
    billName: '供应商通知',
    mainKey: 'Company_Notify_status'
  },
  '200': {
    billName: '供应商登记',
    mainKey: 'B02_Company_Apply_Register_Status'
  }
};

/**
 * 每日提醒 - 路由配置
 * 需和枚举【B02_Daily_Order_Reminder】保持一致
 *
 */
export const DAILY_ORDER_REMINDER = {
  '1001': {
    routerLink: '/mp/sale/customer/order/list',
    queryParams: { remindType: 2 }
  },
  '1002': {
    routerLink: '/mp/sale/customer/order/list'
  },
  '1003': {
    routerLink: '/mp/sale/plan/delivery/board'
  },
  '1004': {
    routerLink: '/mp/sale/customer/order/list'
  },
  '1005': {
    routerLink: '/mp/sale/plan/delivery/board'
  },
  '2701': {
    routerLink: '/mp/sale/customer/iqc/8d-report/list'
  },
  '2702': {
    routerLink: '/mp/purchase/iqc/8d-report/list'
  },
  '4101': {
    routerLink: '/mp/sale/customer/qualification/list'
  },
  '4301': {
    routerLink: '/mp/sale/customer/penalty-notice/list'
  },
  '8201': {
    routerLink: '/mp/sale/customer/prod-graph/list'
  },
  '8301': {
    routerLink: '/mp/sale/customer/my-improvement-report/list'
  },
  '8601': {
    routerLink: '/mp/sale/customer/qualification/list'
  },
  '9201': {
    routerLink: '/mp/sale/customer-sample-order/list'
  },
  '9202': {
    routerLink: '/mp/sale/customer-sample-order/list'
  },
  '9203': {
    routerLink: '/mp/sale/customer-sample-order/list'
  },
  '10101': {
    routerLink: '/mp/sale/customer/questionnaire/list'
  },
  '11001': {
    routerLink: '/mp/notify/list/1',
    queryParams: { currentTab: 1 }
  }
};
